/**
 * Adds a derived `alt` attribute to any <img> inside the PDP product
 * description that was authored without one. Empty `alt=""` is respected
 * (author explicitly marked the image decorative) and left alone.
 *
 * Alt text is derived from the image filename:
 *   .../files/mx2-icon.png?v=921116 -> "mx2 icon"
 */
(function () {
  var ROOT_SELECTOR = '#product-content';

  function deriveAlt(src) {
    if (!src) return '';
    try {
      var path = src.split('?')[0].split('#')[0];
      var file = path.substring(path.lastIndexOf('/') + 1);
      file = file.replace(/\.[a-z0-9]+$/i, '');
      // Drop trailing _NxN size suffixes Shopify appends (e.g. _480x)
      file = file.replace(/_\d+x\d*$/i, '');
      var words = file.replace(/[-_]+/g, ' ').trim();
      return words;
    } catch (e) {
      return '';
    }
  }

  function fixImages(root) {
    if (!root) return;
    var imgs = root.querySelectorAll('img:not([alt])');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var alt = deriveAlt(img.getAttribute('src') || img.getAttribute('data-src') || '');
      img.setAttribute('alt', alt || 'Product description image');
    }
  }

  function init() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return;
    fixImages(root);

    // Watch for late-inserted images (e.g. lazy content, tabs, accordions)
    if ('MutationObserver' in window) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var node = added[j];
            if (node.nodeType !== 1) continue;
            if (node.tagName === 'IMG' && !node.hasAttribute('alt')) {
              var src = node.getAttribute('src') || node.getAttribute('data-src') || '';
              node.setAttribute('alt', deriveAlt(src) || 'Product description image');
            } else if (node.querySelectorAll) {
              fixImages(node);
            }
          }
        }
      });
      observer.observe(root, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
